// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconFolderOpen.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconFolderOpen = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 14" fill="currentColor" { ...props }>
    <path d="M2.52648 5.86667C2.79718 4.90667 3.60926 4.21333 4.51157 4.21333H15.6391C15.8195 4.21333 16 4.05333 16 3.84V2.88C16 2.4 15.6842 2.02667 15.233 2.02667H6.99294C6.5869 2.02667 6.22597 1.65333 6.22597 1.17333V0.853333C6.22597 0.373333 5.91016 0 5.459 0H0.766967C0.31581 0 0 0.373333 0 0.853333V12.9333C0 13.04 0.135347 13.0933 0.180463 12.9867L2.52648 5.86667Z" />
    <path d="M12.9451 14H2.18164C1.7756 14 1.45979 13.52 1.59514 13.0933L3.92507 6.34667C4.0153 6.02667 4.24088 5.81333 4.51157 5.81333H15.275C15.681 5.81333 15.9969 6.29333 15.8615 6.72L13.5316 13.4667C13.4413 13.7867 13.2158 14 12.9451 14Z" />
  </BaseIcon>
);

export default IconFolderOpen;
